module.exports = {
	// API_URL: "https://stage.apirestaurant.drive-eat.fr/mobile",
	// imgUrl : "https://stage.api.drive-eat.fr"

	DEFAULT_SERVICE_TYPES: ["takeAway", "delivery"],
	SERVICE_TYPES_LABELS: {
		takeAway: "A emporter",
		onSite: "Sur place",
		delivery: "En livraison",
	},
};
